import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { defaultCompetitionsExportFieldNames } from "../constants/exportFields.ts";

export const useExportCompetitions = () => {
  const { sport = "", organizationId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultCompetitionsExportFieldNames,
      };
      return await request(`${sport}/o/${organizationId}/competitions/export`, {
        method: "POST",
        body,
      });
    },
  });
};
